@if (isLoading) {
  <mat-spinner></mat-spinner>
}

<div [hidden]="isLoading">
  @if (currentRequest) {
    <h2 class="section-title">
      {{ 'REQUEST_DETAILS.REQUEST_DETAILS' | translate }}
    </h2>

    <div class="request-row">
      <div class="request-field">
        <label>{{ 'REQUEST_DETAILS.REQUESTER' | translate }}</label>
        <p>{{ currentRequest.requester.firstNameEn }} {{ currentRequest.requester.lastNameEn }}</p>
        <p class="muted">{{ currentRequest.requester.email }}</p>
      </div>
      <div class="request-field">
        <label>{{ 'REQUEST_DETAILS.APPROVER' | translate }}</label>
        <p>{{ currentRequest.approver.firstNameEn }} {{ currentRequest.approver.lastNameEn }}</p>
        <p class="muted">{{ currentRequest.approver.email }}</p>
      </div>
    </div>

    <div class="request-row">
      <div class="request-field">
        <label>{{ 'REQUEST_DETAILS.FROM' | translate }}</label>
        <p>{{ currentRequest.fromDate | date: 'dd.MM.yyyy' }} {{ fromDateWeekDay }}</p>
      </div>
      <div class="request-field">
        <label>{{ 'REQUEST_DETAILS.TO' | translate }}</label>
        <p>{{ currentRequest.toDate | date: 'dd.MM.yyyy' }} {{ toDateWeekDay }}</p>
      </div>
    </div>

    <div class="request-row">
      <div class="request-field">
        <label>{{ 'REQUEST_DETAILS.AMOUNT_OF_DAYS' | translate }}</label>
        <p>{{ currentRequest.days }}</p>
      </div>
      <div class="request-field">
        <label>{{ 'REQUEST_DETAILS.VACATION_TYPE' | translate }}</label>
        <p>
          {{ currentRequest.vacationType }}
          @if (currentRequest.subType) {
            <span>({{ currentRequest.subType }})</span>
          }
        </p>
      </div>
    </div>

    <div class="request-row">
      <div class="request-field">
        <label>{{ 'REQUEST_DETAILS.ADDITIONAL_INFORMATION' | translate }}</label>
        <p>{{ currentRequest.additionalInfo || EMPTY_VALUE }}</p>
      </div>
      <div class="request-field">
        <label>{{ 'REQUEST_DETAILS.STATUS' | translate }}</label>
        <p>{{ currentRequest.status }}</p>
      </div>
    </div>

    @if (
      (currentRequest?.vacationType === 'Sick leave' ||
        currentRequest?.vacationType === 'Other paid leave') &&
      currentRequest.filename
    ) {
      <div class="request-row">
        <div class="request-field">
          <label>{{ 'REQUEST_DETAILS.ATTACHED_MEDIA' | translate }}</label>
          <p>
            <button
              mat-icon-button
              (click)="openDetailsPicDialog()"
            >
              <mat-icon>list_alt</mat-icon>
            </button>
          </p>
        </div>
      </div>
    }

    <div class="request-row">
      <div class="request-field">
        <label>{{ 'REQUEST_DETAILS.POSTED_ON' | translate }}</label>
        <p>{{ (currentRequest.createdOn | date: 'dd.MM.yyyy') || EMPTY_VALUE }}</p>
      </div>
      <div class="request-field">
        <label>{{ 'REQUEST_DETAILS.RESOLVED_ON' | translate }}</label>
        @if (currentRequest.status === RequestStatus.PENDING) {
          <p class="unresolved">{{ 'REQUEST_DETAILS.MUST_BE_RESOLVED' | translate }}</p>
        } @else {
          <p>{{ (currentRequest.resolvedOn | date: 'dd.MM.yyyy') || EMPTY_VALUE }}</p>
        }
      </div>
    </div>

    <table mat-table [dataSource]="dayBreakdown" class="breakdown-table">
      <ng-container matColumnDef="date">
        <th mat-header-cell *matHeaderCellDef>{{ 'REQUEST_DETAILS.DATE' | translate }}</th>
        <td mat-cell *matCellDef="let row">{{ row.date | date: 'dd.MM.yyyy' }}</td>
      </ng-container>

      <ng-container matColumnDef="dayType">
        <th mat-header-cell *matHeaderCellDef>{{ 'REQUEST_DETAILS.DAY_TYPE' | translate }}</th>
        <td mat-cell *matCellDef="let row">
          <span class="day-type-cell">
            @if (vacationTypeIcon) {
              <mat-icon class="day-type-icon" aria-hidden="true" [class]="row.iconClass">
                {{ vacationTypeIcon | vacationTypeToIcon }}
              </mat-icon>
            }
           {{ currentRequest.vacationType }}
          </span>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="breakdownColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: breakdownColumns"></tr>
    </table>

    @if (currentRequest && applicableForModification()) {
      <div class="request-actions">
        <button
          mat-flat-button
          color="primary"
          [disabled]="currentRequest.status === RequestStatus.APPROVED"
          (click)="openDialogApprove()"
        >
          {{ 'REQUEST_DETAILS.APPROVE' | translate }}
        </button>
        <button
          mat-flat-button
          color="warn"
          [disabled]="currentRequest.status === RequestStatus.DECLINED"
          (click)="openDialogDecline()"
        >
          {{ 'REQUEST_DETAILS.DECLINE' | translate }}
        </button>
      </div>
    }
  }
</div>
